import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import StarRating from 'vue-star-rating'

Vue.component('v-otp-input', OtpInput)
export default {
  props: ['stars'],
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      rating: 0
    }
  },
  components: {
    StarRating
  },
  computed: {},
  methods: {
    setRating: function (rating) {
      if (this.stars) {
        this.stars(rating)
      }
      // this.rating = rating
    }
  }
}
